module.exports = __webpack_public_path__ + "img/login-background.db5c0ddc.png";